export default {
  nav: {
    firstStep: "first step",
    navigate: "how to navigate",
    whyUs: "why veki?",
    nice: "what a nice",
    shop: "shop",
    shopAll: "everything",
    shopContainers: "containers",
    shopLarvals: "the larvals",
    shopOrganizers: "organizers",
    shopBoxes: "boxes",
    shopCategoryKits: "kits",
    shopCategoryLabels: "labels",
    shopCategoryVouchers: "vouchers",
    organizeDrawer: "organize drawer",
    genDimensions: "submit dimensions",
    genDesign: "design",
    materials: "types of finishes",
    blog: "inspirations",
    myAccount: "my account",
    contact: "contact"
  },
  user: {
    register: {
      email_blank: "User's email can not be empty.",
      password_blank: "User's password can not be empty.",
      success: "Registration successful.",
      user_exists: "User with this name / email already exists."
    },
    login: {
      username_blank: "Username can not be empty.",
      password_blank: "Password can not be empty.",
      invalid_username: "This username is incorrect.",
      incorrect_password: "This password for this user is incorrect.",
      unexpected_error: "An unexpected problem was encountered.",
      success: "Logged in successfully."
    },
    unexpected_error: "An unexpected problem was encountered.",
    forgotten_pass: "Forgotten password?"
  },
  contact: {
    contact_subject_blank: "Message's subject cannot be empty.",
    contact_name_blank: "Sender's name cannot be empty.",
    contact_surname_blank: "Sender's surname cannot be empty.",
    contact_email_blank: "Sender's e-mail cannot be empty.",
    contact_message_blank: "Message cannot be empty.",
    form_success: "Message sent successfuly.",
    form_failed: "An error occured while trying to send the message.",
    expired_captcha: "Captcha expired."
  },
  cart: {
    update: {
      success: "Successfully updated.",
      errror: "Something went wrong during the update."
    },
    shipping: {
      not_enough_data: "Not enough data given to calculate the shipping cost."
    },
    coupon: {
      apply: {
        cart_empty: "Cart cannot be empty.",
        code_blank: "Voucher's code can not be empty.",
        code_invalid: "Provided voucher code is invalid.",
        code_used_up: "Provided voucher has exceeded the usage limit.",
        code_expired: "Provided voucher is expired.",
        success: "Voucher has been successfully added.",
        code_exists: "Provided voucher has already been added.",
        error: "An unexpected problem was encountered."
      },
      remove: {
        code_blank: "Provided voucher code does not exist.",
        success: "Voucher has been successfully removed.",
        code_not_removed: "Voucher has not been removed.",
        error: "An unexpected problem was encountered."
      }
    }
  },
  checkout: {
    click_here: "Click here",
    message: " to login / register."
  },
  country: {
    PL: 'Poland',
    KZ: 'Kazakhstan',
    AL: 'Albania',
    AD: 'Andorra',
    AT: 'Austria',
    BE: 'Bielgia',
    BY: 'Belarus',
    BA: 'Bosnia and Herzegovina',
    BG: 'Bulgaria',
    BG_BG_21: 'Smolyan',
    HR: 'Croatia',
    ME: 'Montenegro',
    CZ: 'Czech Republic',
    DK: 'Denmark',
    EE: 'Estonia',
    FI: 'Finland',
    FR: 'France',
    GR: 'Greece',
    ES: 'Spain',
    NL: 'Netherlands',
    IE: 'Ireland',
    IS: 'Iceland',
    LI: 'liechtenstein',
    LT: 'Lithuania',
    LU: 'Luxembourg',
    MK: 'Macedonia',
    MT: 'malta',
    MC: 'Monaco',
    DE: 'Germany',
    NO: 'Norway',
    PT: 'Portugal',
    RU: 'Russia',
    RO: 'Romania',
    SM: 'San Marino',
    RS: 'Serbia',
    CH: 'Switzerland',
    SE: 'Sweden',
    SK: 'Slovakia',
    SI: 'Slovenia',
    TR: 'Turkey',
    VA: 'Vatican',
    GB: 'United Kingdom',
    HU: 'Hungary',
    IT: 'Italy',
    LV: 'Latvia',
    CA_NS: 'Nova Scotia'
  }
};
